import qz from "qz-tray";

let connected = false;

export const connectQZ = async () => {
  if (connected && qz.websocket.isActive()) {
    return;
  }

  try {
    await qz.websocket.connect();
    connected = true;
    console.log("QZ Tray connected");
  } catch (err) {
    console.error("QZ Tray connection failed:", err);
    alert("Please open QZ Tray and allow permissions.");
    throw err;
  }
};

export const disconnectQZ = async () => {
  try {
    await qz.websocket.disconnect();
    connected = false;
  } catch (err) {
    console.error("QZ Tray disconnect failed:", err);
  }
};
